import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { workspaceApi } from '@/lib/api';
import { CreateWorkspaceRequest } from '@/types';
import { queryKeys } from './shared';

// Workspaces
export const useWorkspaces = () =>
  useQuery({
    queryKey: queryKeys.workspaces,
    queryFn: workspaceApi.list,
  });

export const useWorkspace = (id: string) =>
  useQuery({
    queryKey: queryKeys.workspace(id),
    queryFn: () => workspaceApi.get(id),
    enabled: !!id,
  });

export const useCreateWorkspace = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateWorkspaceRequest) => workspaceApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.workspaces });
    },
  });
};
